<template>
  <div class="wrapper">
    <div class="main">
      <div class="section">
        <!-- Header start -->
        <div class="container" style="margin-top: 3%">
          <div class="md-layout md-alignment-center-center">
            <div class="md-layout-item md-size-33">
              <div class="md-layout">
                <div class="md-layout-item md-size-100">
                  <h2 class="title text-heading-pr">{{ header.title }}</h2>
                </div>
                <div class="md-layout-item md-size-100">
                  <div>{{ header.description }}</div>
                </div>
              </div>
            </div>
            <div class="md-layout-item md-size-25">
              <img
                :src="header.image1"
                style="object-fit: cover; width: 100%;"
              />
            </div>
            <div class="md-layout-item md-size-25">
              <img
                :src="header.image2"
                style="object-fit: cover; width: 100%;"
              />
            </div>
          </div>
        </div>
        <!-- Header End -->

        <!-- Layout begins -->

        <div
          class="md-layout section section-dark"
          style="margin-left:0; margin-right:0; margin-top: 5%"
        >
          <!-- Left slide -->
          <div
            class="md-layout-item md-size-33 md-small-size-100"
            style="height: 50vh; padding:0;"
          >
            <div class="md-layout" style="margin-left:0; margin-right:0;  ">
              <div class="md-layout-item md-size-100">
                <h2 class="title text-heading-pr">Our journey</h2>
              </div>
              <div class="md-layout-item md-size-100 text-white">
                <div
                  v-for="(date, index) in importantDates"
                  :key="index"
                  style="margin-bottom: 2%"
                >
                  <b>{{ date.date }}</b> <br />
                  {{ date.description }}
                  <br />
                </div>
              </div>
            </div>
          </div>

          <div class="md-layout-item md-size-33">
            <img :src="sectionImage" style="object-fit: cover; height: 100%;" />
          </div>

          <div class="md-layout-item md-size-33">
            <h3 class="title text-heading-pr">{{ graphArea.heading }}</h3>
            <br />
            <div v-for="(graph, index) in graphArea.graphs" :key="index">
              <k-progress
                :percent="graph.percent"
                :color="graph.color"
                :active="true"
                :line-height="3"
              />
              <div class="caption">{{ graph.caption }}</div>
              <br />
            </div>
          </div>
        </div>
        <!-- What sets us apart end -->

        <!-- About Us Start -->
        <div class="section">
          <h2 class="title text-center">About Us</h2>
          <div class="md-layout md-alignment-center-center">
            <div
              class="md-layout-item md-size-50 md-small-size-100 text-center"
            >
              {{ aboutUs }}
            </div>
          </div>
        </div>
        <!-- About Us End -->

        <!-- Artysan in the media -->
        <div class="container">
        <!-- <splide :options="inTheMedia.options">
          <splide-slide>
            <h1>Hello</h1>
          </splide-slide>
          <splide-slide>
            <h1>There</h1>
          </splide-slide>
        </splide> -->
        <h2>In the media here</h2>
        </div>

        <!-- Team Start -->
        <div class="" :style="sectionTeam()">
          <div class="container">
            <div class="md-layout">
              <div
                class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"
              >
                <h2 class="title">The Team</h2>
                <br/>
              </div>
            </div>
            <div class="md-layout">
              <div v-for="(person,index) in team" :key="index" class="md-layout-item md-size-33 md-small-size-100">
                <profile-card
                  card-avatar
                  :shadow-normal="false"
                  :no-colored-shadow="false"
                  :card-image="person.image"
                >
                  <template slot="cardContent">
                    <h4 class="card-title">{{person.name}}</h4>
                  </template>
                </profile-card>
              </div>
            </div>  
          </div>
        </div>
        <!-- Team end -->

        <!-- Quote Start -->
        <div class="section section-dark">
          <div class="text-center"><md-icon class=" text-white  md-size-3x">format_quote</md-icon></div>
          
          <div class="md-layout md-alignment-center-center">
            <div
              class="md-layout-item md-size-50 md-small-size-100 text-center text-white"
            >
              {{ aboutUs }}
            </div>
          </div>
        </div>
        <!-- About Us End -->


      </div>
    </div>
  </div>
</template>

<script>
import { Splide, SplideSlide } from "@splidejs/vue-splide";
import { ProfileCard } from "@/components";


export default {
  components: {
    // Splide,
    // SplideSlide
    ProfileCard
  },
  data() {
    return {
      header: {
        title: "WE CREATE DESIGNS AND TECHNOLOGY",
        description: `We are idea-driven, working with a strong focus on design and user experience. Our projects should engage your audience, we want to create wonderful digital things that people love to be part of and use. That's what your brand and audience deserve.`,
        image1: require("@/assets/img/PR/digital pr.jpeg"),
        image2: require("@/assets/img/PR/seo.jpg")
      },
      importantDates: [
        {
          date: "20th October 2020",
          description: "Good day for business."
        },
        {
          date: "23th October 2020",
          description: "Good day for business once more."
        }
      ],
      sectionImage: require("@/assets/img/PR/digital pr.jpeg"),
      graphArea: {
        heading:
          "We provide high quality and cost effective offshore web services.",
        graphs: [
          {
            percent: 80,
            color: "red",
            caption: "JQUERY - 4 YEARS EXPERIENCE"
          },
          {
            percent: 80,
            color: "yellow",
            caption: "JS - 2 YEARS EXPERIENCE"
          }
        ]
      },
      aboutUs: `We are idea-driven, working with a strong focus on design and user experience. Our projects should engage your audience, we want to create wonderful digital things that people love to be part of and use. We are idea-driven, working with a strong focus on design and user experience. Our projects should engage your audience, we want to create wonderful digital things that people love to be part of and use. We are idea-driven, working with a strong focus on design and user experience. Our projects should engage your audience, we want to create wonderful digital things that people love to be part of and use.`,
      inTheMedia: {
        options: {
          type: "loop",
          padding: {
            right: "0",
            left: "0"
          }
        }
      },
      team: [
        {
          name: "Sanchit Mahajan",
          image: require("@/assets/img/PR/team/sanchit.jpg")
        },
        {
          name: "Pratishtha Budhiraja",
          image: require("@/assets/img/PR/team/pratishtha.jpg")
        },
        {
          name: "Pawan Jangid",
          image: require("@/assets/img/PR/team/pawan.jpg")
        },
      ],
    };
  },
  methods: {
    sectionTeam(image) {
      return {
        backgroundImage: `url(${image})`
      };
    },
  }
};
</script>